/* Presentation only: Kiwi owns measurements, charts, recommended sizes, and selection. */
(() => {
  const unitNames = { in: 'inches', cm: 'cm', lbs: 'lbs', kg: 'kg' };
  let scheduled = false;
  function update() {
    scheduled = false;
    document.querySelectorAll('.kiwi-sizing-modal').forEach(modal => {
      const tab = modal.querySelector('.ks-modal-tab.selected')?.dataset.tab || modal.dataset.openTab;
      const title = modal.querySelector('.modal-title-header');
      const label = tab === 'ks-chart-tab-container' ? 'Size Chart' : 'Find Your Size';
      if (title && title.textContent !== label) title.textContent = label;
      const actions = ['fit','chart'].every(action => {
        const button = document.querySelector(`[data-alpha-sizing-action="${action}"]`);
        return button && !button.hidden && !button.disabled;
      });
      if (modal.dataset.alphaKiwiManaged !== String(actions)) modal.dataset.alphaKiwiManaged = String(actions);
      const panel = modal.querySelector('.ks-calculator-tab-container');
      const privacy = panel?.querySelector('.ks-calculator-privacy-link');
      const calculator = panel?.querySelector('.ks-calculator-container');
      if (privacy && calculator && calculator.nextElementSibling !== privacy) calculator.after(privacy);
      modal.querySelectorAll('.ks-calculator-container-content:not(.advanced-calculator) .input-element').forEach(row => {
        const input = row.querySelector('input.element-input');
        const label = row.querySelector('.element-label label');
        if (!input || !label) return;
        const leaf = [...label.querySelectorAll('span')].findLast(span => !span.children.length) || label;
        const match = leaf.textContent.trim().match(/^(.*?)\s*\((in|cm|lbs|kg)\)$/i);
        const unit = (match?.[2] || input.dataset.unit || row.dataset.alphaUnit || '').toLowerCase();
        if (!unitNames[unit]) return;
        if (match) leaf.textContent = match[1];
        if (row.dataset.alphaUnit !== unit) row.dataset.alphaUnit = unit;
        let suffix = row.querySelector('.postfix');
        if (!suffix) {
          suffix = document.createElement('span');
          suffix.className = 'postfix';
          input.after(suffix);
        }
        if (suffix.textContent !== unitNames[unit]) suffix.textContent = unitNames[unit];
        if (!suffix.id) suffix.id = `${label.id}-unit`;
        const describedBy = new Set((input.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean));
        if (!describedBy.has(suffix.id)) {
          describedBy.add(suffix.id);
          input.setAttribute('aria-describedby', [...describedBy].join(' '));
        }
      });
      modal.querySelectorAll('.ks-carousel-content-btn,.ks-carousel-btn').forEach(button => {
        if (button.getAttribute('role') !== 'button') button.setAttribute('role','button');
        if (button.tabIndex !== 0) button.tabIndex = 0;
        const name = button.classList.contains('ks-carousel-left-btn') ? 'Previous size' : button.classList.contains('ks-carousel-right-btn') ? 'Next size' : `See size ${button.textContent.trim()}`;
        if (button.getAttribute('aria-label') !== name) button.setAttribute('aria-label',name);
        if (button.classList.contains('ks-carousel-content-btn')) {
          const pressed = String(button.classList.contains('ks-carousel-mid'));
          if (button.getAttribute('aria-pressed') !== pressed) button.setAttribute('aria-pressed',pressed);
        }
      });
    });
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  }
  const observer = new MutationObserver(records => {
    if (records.some(record => {
      const target = record.target instanceof Element ? record.target : record.target.parentElement;
      return target?.closest('.kiwi-sizing-modal') || [...record.addedNodes].some(node => node instanceof Element && (node.matches('.kiwi-sizing-modal') || node.querySelector('.kiwi-sizing-modal')));
    })) schedule();
  });
  function init() {
    observer.observe(document.body,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['class','data-open-tab','data-unit']});
    document.addEventListener('keydown',event => {
      const button = event.target.closest?.('.kiwi-sizing-modal .ks-carousel-content-btn,.kiwi-sizing-modal .ks-carousel-btn');
      if (button && (event.key === 'Enter' || event.key === ' ')) { event.preventDefault(); button.click(); }
    });
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();
